import { LM_API_KEY_PROD, LM_API_KEY_STAGE, LM_ENDPOINT_PROD, LM_ENDPOINT_STAGE } from "../constant"
import { IS_PROD } from "../util/stage"

const appSyncEndPoint = IS_PROD ? LM_ENDPOINT_PROD : LM_ENDPOINT_STAGE

const headers = {
    "x-api-key": IS_PROD ? LM_API_KEY_PROD : LM_API_KEY_STAGE,
    "Content-Type": "application/json",
}

// NOTE: The comments are examples.
export interface DefaultMarket {
    baseSymbol: string // "vBTC"
    quoteSymbol: string // "vUSD"
    marketSymbol: string // "vBTC/vUSD"

    lowerBaseApr: number // 3.222
    upperBaseApr: number // 215.253

    lowerRewardApr: number // 19.962
    upperRewardApr: number // 927.846
    lowerRewardOpApr: number // 19.962 but for $OP
    upperRewardOpApr: number // 927.846 but for $OP
    rewardCapWeeklyPerp: number // 19.962 but for $PERP
    rewardCapWeeklyOp:number // 19.227 but for $OP
}

// NOTE: The comments are examples.
interface ListMarketAprsResponse {
    items: DefaultMarket[]
    nextToken: string | null // "exampleNextTokenString" | null
}

export async function listMarketAprs(limit = 100, nextToken = ""): Promise<ListMarketAprsResponse | null> {
    const result = await fetch(appSyncEndPoint, {
        method: "POST",
        headers,
        body: JSON.stringify({
            query: `
                query ListMarketAprs($limit:Int!, $nextToken:String!) {  
                    listMarketAprs(limit: $limit, nextToken: $nextToken) {
                        nextToken
                        items {
                            baseSymbol
                            quoteSymbol
                            marketSymbol

                            lowerBaseApr
                            upperBaseApr

                            lowerRewardApr
                            upperRewardApr

                            lowerRewardOpApr
                            upperRewardOpApr

                            rewardCapWeeklyPerp
                            rewardCapWeeklyOp
                        }
                    }
                }
            `,
            variables: { limit, nextToken },
        }),
    })
        .then(res => res.json())
        .catch(error => console.error("error", error))

    return result.data.listMarketAprs
}

//

// NOTE: The comments are examples.
export interface MakerMarket {
    baseSymbol: string //"vETH"
    quoteSymbol: string //"vUSD"
    marketSymbol: string //"vETH/vUSD"

    baseApr: number // 20.99832014815356
    rewardApr: number // 190.50873682456827
    rewardOpApr: number // 190.50873682456827 but for $OP

    netValue: number // 103.652
    estimatedRewardAmount: number // 0.299
    estimatedRewardUsd: number // 3.873
    estimatedRewardOpAmount: number // 0.299 but for $OP
    estimatedRewardOpUsd: number, // 3.873 but for $OP
}

export async function listMakerAprs(address: string): Promise<MakerMarket[] | null> {
    const result = await fetch(appSyncEndPoint, {
        method: "POST",
        headers,
        body: JSON.stringify({
            query: `
                query ListMakerAprs($address:String!) {  
                    listMakerAprs(address: $address) {
                        items {
                            baseSymbol
                            quoteSymbol
                            marketSymbol

                            baseApr
                            rewardApr
                            rewardOpApr 

                            netValue
                            estimatedRewardAmount
                            estimatedRewardUsd
                            estimatedRewardOpAmount 
                            estimatedRewardOpUsd 
                        }
                    }
                }
            `,
            variables: { address },
        }),
    })
        .then(res => res.json())
        .catch(error => console.error("error", error))

    return result.data.listMakerAprs?.items
}

//

export interface ClaimableReward {
    week: number // from 1
    balance: string // wei
    merkleProof: string[]
}
interface ClaimableRewardsResponse {
    items: ClaimableReward[]
    // These are strings because BE is preventing the symbol e in the number.
    totalBalance: string
    totalBalanceUsd: string
    itemsOp: ClaimableReward[]
    // These are strings because BE is preventing the symbol e in the number.
    totalBalanceOp: string
    totalBalanceUsdOp: string
}

export async function getClaimableRewards(address: string): Promise<ClaimableRewardsResponse | null> {
    const result = await fetch(appSyncEndPoint, {
        method: "POST",
        headers,
        body: JSON.stringify({
            query: `
                query GetClaimableRewards($address:String!) {  
                    getClaimableRewards(address: $address) {
                        items {
                            balance
                            merkleProof
                            week
                        }
                        totalBalance
                        totalBalanceUsd
                        itemsOp {
                            balance
                            merkleProof
                            week
                        }
                        totalBalanceOp
                        totalBalanceUsdOp
                    }
                }
            `,
            variables: { address },
        }),
    })
        .then(res => res.json())
        .catch(error => console.error("error", error))

    return result.data.getClaimableRewards
}
